import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';

export const authGuard: CanActivateFn = (route, state) => {

  const oauthService = inject(OAuthService);
  const token = oauthService.getAccessToken();
  const router = inject(Router);

  if (token) {
    return true;
  } else {
    router.navigate(['/welcome'])
    return false;
  }
}

